/* Configurador EuroCycling — reemplazo nativo de Easify.
   Precios: las variantes del producto y los productos de complementos en Shopify son la única fuente de verdad. */
(function () {
  'use strict';

  var fmtEntero = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  var fmtCentavos = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function money(cents) {
    var c = Math.abs(cents);
    return (c % 100 ? fmtCentavos : fmtEntero).format(c / 100);
  }
  function delta(cents) {
    if (!cents) return 'Incluido';
    return (cents > 0 ? '+' : '−') + money(cents);
  }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') n.textContent = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k === 'class') n.className = attrs[k];
        else n.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function valores(campo) {
    return (campo.valores || []).map(function (v) { return typeof v === 'string' ? { label: v } : v; });
  }

  function Configurador(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-ec-data]').textContent);
    this.modo = this.data.modo;
    this.handle = this.data.actual;
    this.sel = {};          // valores elegidos de campos "elegir"
    this.opts = {};         // handle -> valores de opción de variante elegidos
    this.paso = 0;
    this.errores = {};
    var self = this;
    Object.keys(this.data.productos).forEach(function (h) {
      var p = self.data.productos[h];
      var v = p.variants.filter(function (x) { return x.id === p.inicial; })[0] || p.variants[0];
      self.opts[h] = v ? v.options.slice() : [];
    });
    if (!this.data.productos[this.handle]) this.handle = Object.keys(this.data.productos)[0];
    this.aplicarDefaults();
    if (this.modo === 'inline') this.montarInline();
    this.render();
  }

  Configurador.prototype.prod = function () { return this.data.productos[this.handle]; };
  Configurador.prototype.cfg = function () { return this.prod().config || {}; };
  Configurador.prototype.pasos = function () { return this.cfg().pasos || []; };

  Configurador.prototype.campos = function () {
    var out = [];
    this.pasos().forEach(function (p) { (p.campos || []).forEach(function (c) { out.push(c); }); });
    return out;
  };

  Configurador.prototype.aplicarDefaults = function () {
    var self = this;
    this.campos().forEach(function (c) {
      if ((c.tipo || 'elegir') !== 'elegir') return;
      var vals = valores(c).map(function (v) { return v.label; });
      if (self.sel[c.clave] && vals.indexOf(self.sel[c.clave]) === -1) delete self.sel[c.clave];
      if (!self.sel[c.clave] && c['default']) self.sel[c.clave] = c['default'];
    });
  };

  Configurador.prototype.visible = function (c) {
    if (!c.si) return true;
    var actual = this.sel[c.si.campo];
    if (c.si.es !== undefined) return actual === c.si.es;
    if (c.si.no !== undefined) return !!actual && actual !== c.si.no;
    return true;
  };

  /* ---------- variantes ---------- */
  Configurador.prototype.buscarVariante = function (opts, p) {
    p = p || this.prod();
    return p.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  };
  Configurador.prototype.variante = function () {
    if (this.modo === 'inline') {
      var p = this.prod();
      var input = this.form && this.form.querySelector('[name="id"]');
      var id = input ? parseInt(input.value, 10) : p.inicial;
      return p.variants.filter(function (v) { return v.id === id; })[0] || p.variants[0];
    }
    return this.buscarVariante(this.opts[this.handle]);
  };
  Configurador.prototype.indiceOpcion = function (nombre) {
    return this.prod().options.indexOf(nombre);
  };
  Configurador.prototype.precioConOpcion = function (idx, valor) {
    var o = this.opts[this.handle].slice();
    o[idx] = valor;
    var v = this.buscarVariante(o);
    return v ? v : null;
  };

  /* ---------- complementos ---------- */
  Configurador.prototype.addon = function (titulo) {
    return (this.prod().addons || {})[titulo] || null;
  };
  Configurador.prototype.complementos = function () {
    var self = this, out = [];
    this.campos().forEach(function (c) {
      if ((c.tipo || 'elegir') !== 'elegir' || !self.visible(c)) return;
      var elegido = self.sel[c.clave];
      valores(c).forEach(function (v) {
        if (v.label === elegido && v.addon) {
          var a = self.addon(v.addon);
          if (a) out.push({ id: a.id, price: a.price, titulo: v.addon, campo: c.clave, valor: v.label });
        }
      });
    });
    return out;
  };

  Configurador.prototype.total = function () {
    var v = this.variante();
    var base = v ? v.price : 0;
    return base + this.complementos().reduce(function (s, a) { return s + a.price; }, 0);
  };

  /* ---------- validación ---------- */
  Configurador.prototype.faltantes = function (soloPaso) {
    var self = this, faltan = [];
    this.pasos().forEach(function (p, i) {
      if (soloPaso !== undefined && i !== soloPaso) return;
      (p.campos || []).forEach(function (c) {
        if ((c.tipo || 'elegir') === 'elegir' && c.requerido && self.visible(c) && !self.sel[c.clave]) faltan.push({ paso: i, clave: c.clave });
      });
    });
    return faltan;
  };

  /* ---------- progreso ---------- */
  Configurador.prototype.progreso = function () {
    var self = this, total = 0, hechos = 0;
    this.campos().forEach(function (c) {
      if ((c.tipo || 'elegir') !== 'elegir' || !c.requerido || !self.visible(c)) return;
      total++;
      if (self.sel[c.clave]) hechos++;
    });
    return { total: total, hechos: hechos, pct: total ? Math.round(hechos * 100 / total) : 100 };
  };

  Configurador.prototype.renderProgreso = function () {
    var pr = this.progreso();
    var listo = pr.hechos === pr.total;
    var barra = el('div', { class: 'ec-progreso__barra', role: 'progressbar', 'aria-valuemin': '0', 'aria-valuemax': '100', 'aria-valuenow': String(pr.pct) }, [
      el('span', { class: 'ec-progreso__relleno' })
    ]);
    barra.firstChild.style.width = pr.pct + '%';
    return el('div', { class: 'ec-progreso' + (listo ? ' is-listo' : '') }, [
      el('div', { class: 'ec-progreso__texto' }, [
        el('span', { text: listo ? 'Configuración completa' : 'Tu progreso' }),
        el('span', { class: 'ec-progreso__num', text: pr.hechos + ' de ' + pr.total + ' opciones' })
      ]),
      barra
    ]);
  };

  /* Barra fija inferior: total + progreso + agregar */
  Configurador.prototype.renderBarra = function () {
    var self = this;
    if (!this.barra) {
      this.barra = el('div', { class: 'ec-barra', 'aria-hidden': 'true' });
      document.body.appendChild(this.barra);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) {
            self.barra.classList.toggle('is-visible', en.isIntersecting);
            self.barra.setAttribute('aria-hidden', en.isIntersecting ? 'false' : 'true');
          });
        }, { rootMargin: '0px 0px -40% 0px' }).observe(this.root);
      }
    }
    var pr = this.progreso();
    var listo = pr.hechos === pr.total;
    this.barra.innerHTML = '';
    var relleno = el('span', { class: 'ec-barra__relleno' });
    relleno.style.width = pr.pct + '%';
    var btn = el('button', { type: 'button', class: 'button button--primary ec-barra__btn', text: listo ? 'Agregar al carrito' : 'Continuar' });
    btn.addEventListener('click', function () {
      var cta = self.root.querySelector('.ec-resumen__cta');
      if (listo && cta) { cta.click(); return; }
      var f = self.faltantes();
      if (f.length) {
        self.errores = {};
        f.forEach(function (x) { self.errores[x.clave] = true; });
        self.paso = f[0].paso;
        self.render();
        self.enfocarPaso(f[0].paso);
      }
    });
    this.barra.appendChild(el('div', { class: 'ec-barra__progreso' }, [relleno]));
    this.barra.appendChild(el('div', { class: 'ec-barra__fila' }, [
      el('div', { class: 'ec-barra__info' }, [
        el('span', { class: 'ec-barra__label', text: listo ? 'Total · IVA incluido' : 'Llevas ' + pr.hechos + ' de ' + pr.total + ' opciones' }),
        el('strong', { class: 'ec-barra__total', text: money(this.total()) + ' MXN' })
      ]),
      btn
    ]));
  };

  /* ---------- render ---------- */
  Configurador.prototype.render = function () {
    if (this.modo === 'inline') return this.renderInline();
    var self = this;
    var root = this.root;
    root.querySelectorAll(':scope > :not([data-ec-data])').forEach(function (n) { n.remove(); });

    var pasosWrap = el('div', { class: 'ec-cfg__pasos' });
    this.pasos().forEach(function (p, i) {
      pasosWrap.appendChild(self.renderPaso(p, i));
    });

    var head = el('div', { class: 'ec-cfg__head' }, [
      el('p', { class: 'ec-cfg__eyebrow', text: 'Configurador' }),
      el('h2', { class: 'ec-cfg__titulo', text: this.cfg().titulo || 'Arma tu configuración' }),
      this.renderProgreso()
    ]);
    var layout = el('div', { class: 'ec-cfg__layout' }, [pasosWrap, this.renderResumen()]);
    root.appendChild(head);
    root.appendChild(layout);
    this.renderBarra();
  };

  Configurador.prototype.resumenPaso = function (p) {
    var self = this, partes = [];
    (p.campos || []).forEach(function (c) {
      var t = c.tipo || 'elegir';
      if (t === 'formato') partes.push(self.etiquetaFormato());
      else if (t === 'variante') {
        var i = self.indiceOpcion(c.opcion);
        if (i > -1) partes.push(self.opts[self.handle][i]);
      } else if (self.visible(c) && self.sel[c.clave]) partes.push(self.sel[c.clave]);
    });
    return partes.join(' · ');
  };

  Configurador.prototype.etiquetaFormato = function () {
    var f = (this.cfg().formatos || []).filter(function (x) { return x.handle === this.handle; }, this)[0];
    return f ? f.label : this.prod().title;
  };

  Configurador.prototype.renderPaso = function (p, i) {
    var self = this;
    var abierto = i === this.paso;
    var faltan = this.faltantes(i).length;
    var completo = i < this.paso && !faltan;
    var head = el('button', { type: 'button', class: 'ec-paso__head', 'aria-expanded': abierto ? 'true' : 'false' }, [
      el('span', { class: 'ec-paso__num', text: ('0' + (i + 1)).slice(-2) }),
      el('span', { class: 'ec-paso__titulo', text: p.titulo }),
      el('span', { class: 'ec-paso__sel', text: abierto ? '' : this.resumenPaso(p) })
    ]);
    head.addEventListener('click', function () { self.paso = abierto ? -1 : i; self.render(); self.enfocarPaso(i); });

    var paso = el('section', { class: 'ec-paso' + (abierto ? ' is-open' : '') + (completo ? ' is-done' : '') }, [head]);
    if (!abierto) return paso;

    var body = el('div', { class: 'ec-paso__body' });
    if (p.descripcion) body.appendChild(el('p', { class: 'ec-paso__desc', text: p.descripcion }));
    (p.campos || []).forEach(function (c) {
      var n = self.renderCampo(c);
      if (n) body.appendChild(n);
    });
    var ultimo = i === this.pasos().length - 1;
    var sig = el('button', { type: 'button', class: 'button button--secondary ec-paso__next', text: ultimo ? 'Ver resumen' : 'Siguiente' });
    sig.addEventListener('click', function () {
      var f = self.faltantes(i);
      if (f.length) { self.errores = {}; f.forEach(function (x) { self.errores[x.clave] = true; }); self.render(); return; }
      self.errores = {};
      self.paso = ultimo ? -1 : i + 1;
      self.render();
      if (ultimo) { var r = self.root.querySelector('.ec-resumen'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      else self.enfocarPaso(i + 1);
    });
    body.appendChild(sig);
    paso.appendChild(body);
    return paso;
  };

  Configurador.prototype.enfocarPaso = function (i) {
    var n = this.root.querySelectorAll('.ec-paso')[i];
    if (!n) return;
    var top = n.getBoundingClientRect().top + window.pageYOffset - 90;
    if (Math.abs(window.pageYOffset - top) > 40) window.scrollTo({ top: top, behavior: 'smooth' });
  };

  Configurador.prototype.renderCampo = function (c) {
    var t = c.tipo || 'elegir';
    if (t === 'formato') return this.renderFormato();
    if (t === 'variante') return this.renderVariante(c);
    if (!this.visible(c)) return null;
    return this.renderElegir(c);
  };

  Configurador.prototype.fieldset = function (titulo, requerido, ayuda, error) {
    var legend = el('legend', { class: 'ec-campo__titulo', text: titulo });
    if (requerido) legend.appendChild(el('span', { class: 'ec-campo__req', text: ' *' }));
    var fs = el('fieldset', { class: 'ec-campo' + (error ? ' has-error' : '') }, [legend]);
    if (ayuda) fs.appendChild(el('p', { class: 'ec-campo__ayuda', text: ayuda }));
    if (error) fs.appendChild(el('p', { class: 'ec-campo__error', text: 'Elige una opción para continuar.' }));
    return fs;
  };

  Configurador.prototype.boton = function (label, precio, nota, activo, deshabilitado, onClick) {
    var b = el('button', { type: 'button', class: 'ec-opt' + (activo ? ' is-active' : ''), 'aria-pressed': activo ? 'true' : 'false' }, [
      el('span', { class: 'ec-opt__label', text: label }),
      nota ? el('span', { class: 'ec-opt__nota', text: nota }) : null,
      precio !== null ? el('span', { class: 'ec-opt__precio' + (/^−/.test(precio) ? ' is-menos' : (/^\+/.test(precio) ? ' is-mas' : '')), text: precio }) : null
    ]);
    if (deshabilitado) { b.disabled = true; b.classList.add('is-disabled'); }
    b.addEventListener('click', onClick);
    return b;
  };

  Configurador.prototype.renderFormato = function () {
    var self = this, formatos = this.cfg().formatos || [];
    if (formatos.length < 2) return null;
    var fs = this.fieldset('Formato', false);
    var grid = el('div', { class: 'ec-opts ec-opts--grande' });
    formatos.forEach(function (f) {
      var p = self.data.productos[f.handle];
      if (!p) return;
      var desde = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
      var base = p.variants.filter(function (v) { return v.id === p.inicial; })[0] || p.variants[0];
      grid.appendChild(self.boton(f.label, 'Desde ' + money(base ? base.price : desde), f.nota, f.handle === self.handle, false, function () {
        if (f.handle === self.handle) return;
        self.handle = f.handle;
        self.aplicarDefaults();
        self.errores = {};
        self.render();
        self.enfocarPaso(0);
      }));
    });
    fs.appendChild(grid);
    return fs;
  };

  Configurador.prototype.renderVariante = function (c) {
    var self = this, p = this.prod();
    var idx = this.indiceOpcion(c.opcion);
    if (idx === -1) return null;
    var baseVar = p.variants.filter(function (v) { return v.id === p.inicial; })[0] || p.variants[0];
    var baseValor = baseVar.options[idx];
    var vistos = [];
    p.variants.forEach(function (v) { if (vistos.indexOf(v.options[idx]) === -1) vistos.push(v.options[idx]); });
    var fs = this.fieldset(c.titulo || c.opcion, false, c.ayuda);
    var grid = el('div', { class: 'ec-opts' });
    var refBase = this.precioConOpcion(idx, baseValor);
    vistos.forEach(function (valor) {
      var v = self.precioConOpcion(idx, valor);
      var d = v && refBase ? v.price - refBase.price : null;
      var nota = c.notas && c.notas[valor];
      grid.appendChild(self.boton(valor, v ? delta(d) : 'No disponible', nota, self.opts[self.handle][idx] === valor, !v || !v.available, function () {
        self.opts[self.handle][idx] = valor;
        self.render();
      }));
    });
    fs.appendChild(grid);
    return fs;
  };

  Configurador.prototype.renderElegir = function (c) {
    var self = this;
    var fs = this.fieldset(c.clave, c.requerido, c.ayuda, this.errores[c.clave]);
    var vals = valores(c);
    var precioDe = function (v) {
      if (!v.addon) return null;
      var a = self.addon(v.addon);
      return a ? '+' + money(a.price) : null;
    };
    if (c.control === 'select') {
      var sel = el('select', { class: 'ec-select select__select', 'aria-label': c.clave });
      sel.appendChild(el('option', { value: '', text: 'Selecciona…' }));
      vals.forEach(function (v) {
        var pr = precioDe(v);
        var o = el('option', { value: v.label, text: v.label + (pr ? '  (' + pr + ')' : '') });
        if (self.sel[c.clave] === v.label) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        if (sel.value) self.sel[c.clave] = sel.value; else delete self.sel[c.clave];
        delete self.errores[c.clave];
        self.render();
      });
      fs.appendChild(el('div', { class: 'select ec-select-wrap' }, [sel]));
      return fs;
    }
    var grid = el('div', { class: 'ec-opts' });
    vals.forEach(function (v) {
      var pr = precioDe(v);
      grid.appendChild(self.boton(v.label, pr, v.nota, self.sel[c.clave] === v.label, false, function () {
        if (!c.requerido && !c['default'] && self.sel[c.clave] === v.label) delete self.sel[c.clave];
        else self.sel[c.clave] = v.label;
        delete self.errores[c.clave];
        self.render();
      }));
    });
    fs.appendChild(grid);
    return fs;
  };

  Configurador.prototype.textoEntrega = function () {
    var e = this.cfg().entrega || {};
    var v = this.variante();
    var stock = v && v.tracked && v.qty > 0 && !this.complementos().length;
    return stock ? e.stock : e.pedido;
  };

  Configurador.prototype.renderResumen = function () {
    var self = this, p = this.prod(), v = this.variante();
    var lista = el('ul', { class: 'ec-resumen__lista' });
    var linea = function (k, val, precio) {
      lista.appendChild(el('li', null, [
        el('span', { class: 'ec-resumen__k', text: k }),
        el('span', { class: 'ec-resumen__v', text: val }),
        precio ? el('span', { class: 'ec-resumen__p', text: precio }) : null
      ]));
    };
    linea('Formato', this.etiquetaFormato(), v ? money(v.price) : null);
    if (v) p.options.forEach(function (o, i) { linea(o, v.options[i]); });
    this.campos().forEach(function (c) {
      if ((c.tipo || 'elegir') !== 'elegir' || !self.visible(c) || !self.sel[c.clave]) return;
      var a = self.complementos().filter(function (x) { return x.campo === c.clave; })[0];
      linea(c.clave, self.sel[c.clave], a ? '+' + money(a.price) : null);
    });

    var faltan = this.faltantes();
    var btn = el('button', { type: 'button', class: 'button button--primary button--full-width ec-resumen__cta' }, [
      el('span', { text: 'Agregar al carrito' })
    ]);
    var aviso = el('p', { class: 'ec-resumen__aviso' + (faltan.length ? '' : ' is-hidden'), text: faltan.length ? 'Faltan ' + faltan.length + ' opción(es) por elegir.' : '' });
    var err = el('p', { class: 'ec-resumen__error', role: 'alert' });
    btn.addEventListener('click', function () {
      var f = self.faltantes();
      if (f.length) {
        self.errores = {};
        f.forEach(function (x) { self.errores[x.clave] = true; });
        self.paso = f[0].paso;
        self.render();
        self.enfocarPaso(f[0].paso);
        return;
      }
      self.agregar(btn, err, 1);
    });

    var extras = this.cfg().extras_texto;
    return el('aside', { class: 'ec-resumen' }, [
      el('p', { class: 'ec-cfg__eyebrow', text: 'Tu configuración' }),
      el('p', { class: 'ec-resumen__producto', text: p.title }),
      lista,
      el('div', { class: 'ec-resumen__total' }, [
        el('span', { text: 'Total · IVA incluido' }),
        el('strong', { text: money(this.total()) + ' MXN' })
      ]),
      el('p', { class: 'ec-resumen__entrega', text: this.textoEntrega() || '' }),
      extras ? el('p', { class: 'ec-resumen__extras', text: extras }) : null,
      aviso,
      btn,
      err
    ]);
  };

  /* ---------- carrito ---------- */
  Configurador.prototype.propiedades = function () {
    var self = this, props = {};
    this.campos().forEach(function (c) {
      if ((c.tipo || 'elegir') === 'elegir' && self.visible(c) && self.sel[c.clave]) props[c.clave] = self.sel[c.clave];
    });
    return props;
  };

  Configurador.prototype.agregar = function (btn, err, cantidad, idVariante) {
    var self = this, p = this.prod();
    var v = idVariante ? { id: idVariante } : this.variante();
    if (!v) { err.textContent = 'Esta combinación no está disponible.'; return Promise.resolve(); }
    var items = [{ id: v.id, quantity: cantidad, properties: this.propiedades() }];
    this.complementos().forEach(function (a) {
      items.push({ id: a.id, quantity: cantidad, properties: { 'Para': p.title, 'Opción': a.campo + ': ' + a.valor } });
    });
    btn.disabled = true;
    btn.classList.add('loading');
    err.textContent = '';
    return fetch(this.data.root.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo agregar al carrito.');
      window.location.href = self.data.root.replace(/\/$/, '') + '/cart';
    }).catch(function (e) {
      err.textContent = e.message || 'No se pudo agregar al carrito.';
      btn.disabled = false;
      btn.classList.remove('loading');
    });
  };

  /* ---------- modo inline (Gemini, Frame 32) ---------- */
  Configurador.prototype.montarInline = function () {
    var self = this;
    var pf = document.querySelector('product-form');
    this.form = pf ? pf.querySelector('form') : null;
    var destino = document.querySelector('.product-form__quantity') || (pf && pf.parentElement);
    if (destino && destino.parentNode) destino.parentNode.insertBefore(this.root, destino);
    var info = this.root.closest('.product__info-container') || document;
    info.addEventListener('change', function () { setTimeout(function () { self.renderInline(); }, 60); });
    if (!this.form) return;
    document.addEventListener('submit', function (e) {
      if (e.target !== self.form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var f = self.faltantes();
      if (f.length) {
        self.errores = {};
        f.forEach(function (x) { self.errores[x.clave] = true; });
        self.renderInline();
        self.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var fd = new FormData(self.form);
      var cantidad = parseInt(fd.get('quantity'), 10) || 1;
      var id = parseInt(fd.get('id'), 10);
      var btn = self.form.querySelector('[type="submit"]') || document.createElement('button');
      var err = self.root.querySelector('.ec-inline__error');
      self.agregar(btn, err, cantidad, id);
    }, true);
  };

  Configurador.prototype.renderInline = function () {
    var self = this;
    this.root.querySelectorAll(':scope > :not([data-ec-data])').forEach(function (n) { n.remove(); });
    var wrap = el('div', { class: 'ec-inline' });
    this.campos().forEach(function (c) {
      var n = self.renderCampo(c);
      if (n) wrap.appendChild(n);
    });
    var extra = this.complementos().reduce(function (s, a) { return s + a.price; }, 0);
    if (extra) {
      wrap.appendChild(el('p', { class: 'ec-inline__total' }, [
        el('span', { text: 'Personalización +' + money(extra) + ' · Total ' }),
        el('strong', { text: money(this.total()) + ' MXN' })
      ]));
    }
    wrap.appendChild(el('p', { class: 'ec-inline__error ec-resumen__error', role: 'alert' }));
    this.root.appendChild(wrap);
  };

  function iniciar() {
    document.querySelectorAll('[data-ec-cfg]').forEach(function (root) {
      if (root.__ec) return;
      try { root.__ec = new Configurador(root); } catch (e) { console.error('[EC configurador]', e); }
    });
    document.querySelectorAll('[data-ec-abrir]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('configurador');
        if (!t) return;
        e.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
